// One-shot handoff of the New Session composer's first message to the new
// conversation: the composer stashes it keyed by conversation id, the
// conversation consumes it once on mount. Keying by id (not router-history
// state) makes leaks into another conversation or back-nav replays impossible.

export interface PendingFirstMessage {
  message: string;
  attachmentIds: string[];
}

const queue = new Map<string, PendingFirstMessage>();

export function stashPendingFirstMessage(
  conversationId: string,
  payload: PendingFirstMessage
): void {
  queue.set(conversationId, payload);
}

// Whether a first message is still queued for this conversation. Non-destructive
// — used to show the New Session skeleton while /connect loads.
export function hasPendingFirstMessage(conversationId: string): boolean {
  return queue.has(conversationId);
}

// Read and remove this conversation's queued first message, if any.
export function takePendingFirstMessage(conversationId: string): PendingFirstMessage | undefined {
  const payload = queue.get(conversationId);
  queue.delete(conversationId);
  return payload;
}
